import { useEffect } from "react";

function useClickOutside(ref, onClickEvent, dependencyVar) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if (onClickEvent)
                    onClickEvent();
            }
        }
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [ref, dependencyVar]);
}

export default useClickOutside;